let settingsState = {
  isOpen: false,
  listeners: [] as (() => void)[],
};

export const settingsManager = {
  toggle: () => {
    settingsState.isOpen = !settingsState.isOpen;
    settingsState.listeners.forEach((listener) => listener());
  },

  set: (value: boolean) => {
    if (settingsState.isOpen !== value) {
      settingsState.isOpen = value;
      settingsState.listeners.forEach((listener) => listener());
    }
  },

  getState: () => settingsState.isOpen,

  subscribe: (listener: () => void) => {
    settingsState.listeners.push(listener);
    return () => {
      settingsState.listeners = settingsState.listeners.filter((l) => l !== listener);
    };
  },

  unsubscribe: (listener: () => void) => {
    settingsState.listeners = settingsState.listeners.filter((l) => l !== listener);
  },
};
